const documentTabConfig = [
  {
    label: "Institution Memory",
    tabValue: 0,
    value: "institution-memory",
    permissionCode: "menu.institution.memory",
  },
  {
    label: "MOUs",
    tabValue: 1,
    value: "mous",
    permissionCode: "submenu.mous",
  },
  {
    label: "Contracts",
    tabValue: 2,
    value: "contracts",
    permissionCode: "submenu.contracts",
  },
  {
    label: "Publications",
    tabValue: 3,
    value: "publications",
    permissionCode: "submenu.publications",
  },
  {
    label: "Manuals",
    tabValue: 4,
    value: "manuals",
    permissionCode: "submenu.manuals",
  },
  {
    label: "Policies",
    tabValue: 5,
    value: "policies",
    permissionCode: "submenu.policies",
    subcategories: [
      {
        label: "Internal Rules",
        value: "internal-rules",
        permissionCode: "submenu.policies.internal_rules",
      },
      {
        label: "Laws",
        value: "laws",
        permissionCode: "submenu.policies.laws",
      },
      {
        label: "SOPs",
        value: "sops",
        permissionCode: "submenu.policies.sops",
      },
      {
        label: "Quarterly",
        value: "quotaly",
        permissionCode: "submenu.policies.quarterly",
      },
    ],
  },
  {
    label: "Planning",
    tabValue: 6,
    value: "planning",
    permissionCode: "submenu.planning",
    subcategories: [
      {
        label: "Strategic Plan",
        value: "strategic-plan",
        permissionCode: "submenu.planning.strategic",
      },
      {
        label: "Action Plan",
        value: "action-plan",
        permissionCode: "submenu.planning.action",
      },
      {
        label: "Budgets",
        value: "budgets",
        permissionCode: "submenu.planning.budgets",
      },
      {
        label: "M&E Matrics",
        value: "me-matrics",
        permissionCode: "submenu.planning.metrics",
      },
      {
        label: "Procurement",
        value: "procurement",
        permissionCode: "submenu.planning.procurement",
      },
    ],
  },
  {
    label: "Templates",
    tabValue: 7,
    value: "templates",
    permissionCode: "submenu.templates",
  },
  {
    label: "Report",
    tabValue: 8,
    value: "report",
    permissionCode: "submenu.report",
    subcategories: [
      {
        label: "Audit",
        value: "audit",
        permissionCode: "submenu.report.audit",
      },
      {
        label: "Financial",
        value: "financial",
        permissionCode: "submenu.report.financial",
      },
      {
        label: "Annual",
        value: "annual",
        permissionCode: "submenu.report.annual",
      },
      {
        label: "Quarterly",
        value: "quotaly",
        permissionCode: "submenu.report.quarterly",
      },
    ],
  },
  {
    label: "Others",
    tabValue: 9,
    value: "others",
    permissionCode: "submenu.others",
  },
];

export const getFilteredTabs = (permissions) => {
  if (!permissions || permissions.length === 0) {
    return documentTabConfig;
  }

  const filtered = documentTabConfig
    .map((tab) => {
      // Create a copy of the tab
      const filteredTab = { ...tab };

      // If tab has subcategories, filter them based on permissions
      if (tab.subcategories) {
        filteredTab.subcategories = tab.subcategories.filter(
          (subcat) =>
            !subcat.permissionCode ||
            permissions.includes(subcat.permissionCode)
        );

        // Only include tab if it has subcategories with permissions
        // or if the tab itself has permission
        if (
          filteredTab.subcategories.length === 0 &&
          (!tab.permissionCode || !permissions.includes(tab.permissionCode))
        ) {
          return null;
        }
      } else if (
        tab.permissionCode &&
        !permissions.includes(tab.permissionCode)
      ) {
        // Filter out tabs without permission
        return null;
      }

      return filteredTab;
    })
    .filter(Boolean); // Remove null entries

  return filtered;
};

export const getTabByValue = (value) => {
  return documentTabConfig.find((tab) => tab.value === value);
};

export const getTabByIndex = (index) => {
  return documentTabConfig[index];
};

export default documentTabConfig;
